<div [class]="theme" class="example-container">
	<img class="logo" src="./assets/corecloud.svg" />
	<h1 class="center mat-headline-5" style="margin-top: 16px">
		{{ 'login.headerWelcome.label' | translate }}
	</h1>
</div>
